import React from "react";

import MainTitle from "./Titles/MainTitle"; 


const ReusableBanner = ({title, description, className='bg-primary-dark', titleColor='text-accent-gold'}) => {
    return (
        <div className={`flex flex-col items-center justify-center py-12 md:py:16 lg:py-24 text-center ${className}`}>
            <MainTitle
                title={title}
            className={titleColor}
/>
            <p className={`paragraph text-sm sm:text-base md:text-lg lg:text-xl font-medium ${titleColor === 'text-accent-gold' ? 'text-accent-gold' : 'text-text-primary'}`}>{description}</p>
        </div>
    );
}

export default ReusableBanner;